module.exports = __webpack_public_path__ + "img/img3.27aa963c.png";